import { PatientCaseContent, SlideShowSlideType } from '@llx/common';
import { useCallback, useEffect } from 'react';

import { useLoggedInUserAuthContext } from '@/components/AuthTokenContextProvider/UserAuthContext';
import { useContextType } from '@/hooks/useContextType';
import findSlideInPatientCase from '@/utils/helpers/findSlideInPatientCase';

import { CaseSlideProps } from '../CaseSlide';
import { useSlideShowStore } from './slideShowData.store';
import SlideShowSlideView from './SlideShowSlideView';
import useSlideVariations from '../hooks/useSlideVariation';

type Props = {
  slide: SlideShowSlideType;
  currentPatientCaseId: string | null;
  currentCase: PatientCaseContent;
  caseSlideProps: CaseSlideProps;
};

export default function SlideShowSlideClient({
  slide,
  currentCase,
  caseSlideProps,
  currentPatientCaseId,
}: Props) {
  const { userID } = useLoggedInUserAuthContext();
  const { contextType, objId } = useContextType();
  const slideShowStore = useSlideShowStore();
  const currentSubSlide = slideShowStore.subSlides[slideShowStore.currentSubSlideIdx];

  const variationDetails = useSlideVariations(
    contextType,
    objId,
    currentPatientCaseId,
    caseSlideProps.isHost,
    currentSubSlide,
    currentCase.variations,
    userID
  );

  const onChangeSubSlide = useCallback(
    (index: number) => {
      if (index < 0 || index >= slideShowStore.subSlides.length) {
        return;
      }
      slideShowStore.setCurrentSubSlideIdx(index);
    },
    [slideShowStore.setCurrentSubSlideIdx, slideShowStore.subSlides]
  );

  useEffect(() => {
    const newSubSlides = slide.items.map((item) => {
      const subSlide = findSlideInPatientCase(item.slideRef, currentCase);
      return subSlide;
    });
    slideShowStore.setSubslides(newSubSlides);
  }, [slide, currentCase]);

  return (
    <SlideShowSlideView
      subSlides={slideShowStore.subSlides}
      currentSubSlide={currentSubSlide}
      onChangeSubSlide={onChangeSubSlide}
      caseSlideProps={caseSlideProps}
      variationDetails={variationDetails}
    />
  );
}
